import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Se descarga al instante?',
  answer: 'Sí. Apenas completás tu compra, recibís acceso inmediato a todo el material en formato digital.'
}, {
  question: '¿Sirve si mi ansiedad es más fuerte de noche?',
  answer: 'Absolutamente. El bono Dormí en Paz está diseñado específicamente para ansiedad nocturna e insomnio.'
}, {
  question: '¿Incluye los 6 bonos?',
  answer: 'Sí. Los 6 bonos premium están incluidos sin costo adicional con tu compra hoy.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Todo es 100% digital. Recibís un email con los links de descarga inmediatamente después de tu compra.'
}, {
  question: '¿Es apto para principiantes?',
  answer: 'Totalmente. El sistema está diseñado para cualquier persona, sin importar si nunca hiciste ejercicios de este tipo antes.'
}, {
  question: '¿Tiene upgrade premium?',
  answer: 'Sí. Después de tu compra vas a poder acceder al Protocolo Premium de Calma Total como upgrade opcional.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-beige-light" data-id="element-50">
      <div className="max-w-3xl mx-auto px-6" data-id="element-51">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-53">
            Preguntas frecuentes
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-54"></div>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-55">
          {faqs.map((faq, index) => <motion.div key={index} className="bg-white rounded-2xl border border-beige-dark/50 overflow-hidden" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-56">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-57">
                <span className="font-medium text-navy pr-4" data-id="element-58">
                  {faq.question}
                </span>
                <ChevronDown size={20} className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-59" />
              </button>

              <AnimatePresence data-id="element-60">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-61">
                    <div className="px-6 pb-5 text-slate leading-relaxed border-t border-beige-light pt-4" data-id="element-62">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        
      </div>
    </section>;
}